import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@drone-js/core';
import { Departure, DepartureCardProps } from 'component/page/detail/MoreInfoSections/DepartureAndReturn/Departure';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

export interface DepartureProps {
    isDeparture: boolean;
    departureList: DepartureCardProps[];
}

const DepartureCard: React.FC<DepartureProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    return (
        <Box pt="8" data-testid={props.isDeparture ? 'departure' : 'return'}>
            <Typography variant="body-s" tag="h3" mb="4">
                {props.isDeparture ? cms[130727] : cms[130728]}
            </Typography>
            {props.departureList && props.departureList.length > 0 ? (
                props.departureList.map((departure) => (
                    <Departure
                        key={departure.id}
                        description={departure.description}
                        locationDescription={departure.locationDescription}
                        id={departure.id}
                        contentLocale={departure.contentLocale}
                    />
                ))
            ) : (
                <Typography variant="body-s" py="8" textColor="base.default">
                    {cms[130730]}
                </Typography>
            )}
        </Box>
    );
};
DepartureCard.displayName = 'DepartureCard';

export default DepartureCard;
